import t from "react";
import { cls as p } from "../../../../helpers/cls.js";
import "../../../Badge/Badge.js";
import { FavoriteButton as c } from "../FavoriteButton/index.js";
import { FavoritesCount as s } from "../FavoritesCount/index.js";
import "../LinkWrapper/index.js";
import "../../../Text/Text.js";
import "@olxbr/ds-icons";
import "../Title/index.js";
import "../AdCardHead/index.js";
import "../AdCardBody/index.js";
const a = _ref => {
  let {
    listId: i,
    favoritesCount: l = 0,
    isFavorited: m,
    showFavoriteButton: o = !0,
    favoriteHandler: r,
    isVerticalSlimCard: n
  } = _ref;
  const d = e => {
    e.stopPropagation(), e.preventDefault(), r == null || r(i);
  };
  return t.createElement(t.Fragment, null, o && t.createElement("div", {
    className: p("olx-ad-card__favorite-container", n && "olx-ad-card__favorite-container--vertical-slim")
  }, t.createElement(s, null, l), t.createElement(c, {
    isFavorited: m,
    onFavoriteClick: d
  }, o)));
};
a.displayName = "AdCardFooter";
export { a as AdCardFooter };